import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseEquipmentTiersProps<T> = {
  filters?: {
    search?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useEquipmentTiers = <T,>({
  filters: { search = '', page } = {},
  mapper = Mapper.default<T>(),
}: UseEquipmentTiersProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['equipmentTiers', search, page],
    queryFn: () => {
      return privateAxios.get('/equipment_tiers', {
        params: {
          search,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
